(function initializeSeaMeProcessScroll(root) {
  class SeaMeProcessScroll extends HTMLElement {
    #controller = null;
    #resizeObserver = null;
    #pointerId = null;
    #startX = 0;
    #startScrollLeft = 0;
    #moved = false;
    #blockClick = false;

    connectedCallback() {
      this.#controller?.abort();
      this.#resizeObserver?.disconnect();
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      const updateScrollable = () => {
        this.dataset.scrollable = this.scrollWidth > this.clientWidth + 1 ? 'true' : 'false';
      };

      this.addEventListener(
        'pointerdown',
        (event) => {
          if (event.button !== 0 || this.dataset.scrollable !== 'true') return;

          this.#pointerId = event.pointerId;
          this.#startX = event.clientX;
          this.#startScrollLeft = this.scrollLeft;
          this.#moved = false;
          this.setPointerCapture(event.pointerId);
          this.classList.add('is-dragging');
        },
        { signal }
      );

      this.addEventListener(
        'pointermove',
        (event) => {
          if (event.pointerId !== this.#pointerId) return;

          const distance = event.clientX - this.#startX;
          if (Math.abs(distance) > 3) this.#moved = true;
          this.scrollLeft = this.#startScrollLeft - distance;
        },
        { signal }
      );

      const finishDrag = (event) => {
        if (event.pointerId !== this.#pointerId) return;

        if (this.hasPointerCapture(event.pointerId)) {
          this.releasePointerCapture(event.pointerId);
        }
        this.#pointerId = null;
        this.#blockClick = this.#moved;
        this.classList.remove('is-dragging');
      };

      this.addEventListener('pointerup', finishDrag, { signal });
      this.addEventListener('pointercancel', finishDrag, { signal });
      this.addEventListener(
        'click',
        (event) => {
          if (!this.#blockClick) return;
          event.preventDefault();
          event.stopPropagation();
          this.#blockClick = false;
        },
        { capture: true, signal }
      );

      if ('ResizeObserver' in root) {
        this.#resizeObserver = new ResizeObserver(updateScrollable);
        this.#resizeObserver.observe(this);
        Array.from(this.children).forEach((child) => this.#resizeObserver.observe(child));
      } else {
        root.addEventListener('resize', updateScrollable, { signal });
      }

      this.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', updateScrollable, { once: true, signal });
      });

      updateScrollable();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
      this.#resizeObserver?.disconnect();
      this.#resizeObserver = null;
    }
  }

  if (!root.customElements.get('seame-process-scroll')) {
    root.customElements.define('seame-process-scroll', SeaMeProcessScroll);
  }
})(window);
